import { useMemo } from "react";

import cx from "classnames";
import Skeleton from "react-loading-skeleton";

import { HIDDEN_SIDEBAR_ROUTES } from "fixtures/constants";

const Loader = () => {
  return <div className="loader" />;
};

// TODO: Combine memos
export const PageLoader = ({
  large = false,
  width: customWidth = 0,
  text = "",
}) => {
  const pathname = window.location.pathname;
  const isSidebarVisible = useMemo(
    () => !HIDDEN_SIDEBAR_ROUTES.includes(pathname),
    [pathname]
  );

  const width = useMemo(() => {
    if (customWidth) {
      return customWidth;
    }
    return isSidebarVisible && !large
      ? window.innerWidth - 250
      : window.innerWidth;
  }, [isSidebarVisible]);

  const height = useMemo(() => {
    return isSidebarVisible && !large
      ? window.innerHeight - 65
      : window.innerHeight;
  }, [isSidebarVisible]);

  return (
    <div
      className={cx("page-loader bg-antd-colorBgLayout", {
        "page-loader--large": large,
      })}
      style={{
        height,
        width,
      }}
    >
      <div className="loader" />
      {text && <p className="loader__text">{text}</p>}
    </div>
  );
};

export const PostSkeleton = ({
  showButtons = true,
}: {
  showButtons?: boolean;
}) => {
  return (
    <div className="w-full max-w-3xl mx-auto flex flex-col mb-10">
      <div className="bg-antd-colorBgContainer border border-antd-colorBorder rounded-lg w-full max-w-sm shadow-md relative mx-auto p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center space-x-2">
            <Skeleton circle width={32} height={32} />
            <Skeleton width={100} height={16} />
          </div>
          <Skeleton circle width={24} height={24} />
        </div>

        <div className="relative border-t border-b border-antd-colorBorderSecondary mb-3">
          <Skeleton
            className="block !w-full"
            height={window.innerWidth > 600 ? 399 : 300}
          />
        </div>

        {showButtons && (
          <div className="flex justify-between items-center pt-3">
            <div className="flex space-x-2">
              <Skeleton circle width={32} height={32} />
              <Skeleton circle width={32} height={32} />
            </div>
            <Skeleton width={100} height={32} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Loader;
